import ProgressPopup from '../../components/organisms/progress/ProgressPopup';
import {
    useModalStore,
} from '../../stores/modal-store';
import {
    useProfileStore,
} from '../../stores/profile-store';
import {
    useAuth,
} from '../../stores/user-store';

export default async function profileExists() {
    const profile = useProfileStore();
    const auth = useAuth();

    if (!auth.isLoggedIn) {
        return {
            name: 'login',
        };
    }
    if (profile.exists) return true;

    const modal = useModalStore();
    modal.show({
        component: ProgressPopup,
        type: 'progress',
    });

    await profile.fetchProfile();

    modal.hide();

    if (profile.exists) return true;

    // eslint-disable-next-line consistent-return
    return { name: 'cv-landing-page' };
}
